import gql from 'graphql-tag';

export const getBluetoothHub = gql`
  query ($deviceId: Int) {
    getBluetoothHub(deviceId: $deviceId) {
      deviceId
      application {
        applicationId
      }
      name
      model {
        modelId
        name
      }
      serial
      mac
      region
      longitude
      latitude
      distance
      remark
      optional
      date
      connect: Boolean
	    bluetoothEnable
	    bluetoothStructure
	    wifiMac
      battery
      live
      humidity
      temperature
      tags
      compositionData
      unicastAddr
      meshStatus
    }
  }
`
